module.exports = __webpack_public_path__ + "media/images/logos/elp-global-1c258d55fda46eb1a55e6f39836ac19d.svg";